/**
 * Hook for using enhanced API service with authentication
 * Provides access to enhanced API service with inline MSAL authentication
 */

import { enhancedApiService } from '../services/enhancedApiService';

/**
 * Hook that provides access to the enhanced API service
 * Service handles authentication internally using inline MSAL token acquisition
 */
export const useEnhancedApi = () => {
  // Enhanced API service handles tokens internally with inline MSAL - no setup needed
  return enhancedApiService;
};
